import {
  CreateServiceRequestDto,
  CreateServiceRequestEntity,
  GetServiceRequestEntity,
  GetServiceRequestFilesEntity,
  ServiceRequestCategoryEntity,
  ServiceRequestUrgencyEntity,

} from '../../entities'
import { api, AxiosRequestConfigWithMetadata } from '../../services/api.service'

class ServiceRequestApi {
  async createServiceRequest(serviceRequest: CreateServiceRequestDto, attachments: File[]): Promise<CreateServiceRequestEntity> {
    const apiCall = await api.post('/api/service-request', {...serviceRequest, files: attachments}, {
      timeout: 500000,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      functionName: 'serviceRequest_createServiceRequest'
    } as AxiosRequestConfigWithMetadata)
    return apiCall.data
  }

  async getCategories(lang: string): Promise<ServiceRequestCategoryEntity[]> {
    const apiCall = await api.get(`/api/service-request/categories/lang/${lang}`, {
      functionName: 'serviceRequest_getCategories'
    } as AxiosRequestConfigWithMetadata)
    return apiCall.data
  }

  async getUrgencies(): Promise<ServiceRequestUrgencyEntity[]> {
    const apiCall = await api.get('/api/service-request/urgencies', {
      functionName: 'serviceRequest_getUrgencies'
    } as AxiosRequestConfigWithMetadata)
    return apiCall.data
  }

  async getServiceRequestsByContractNumber(contractNumber: string): Promise<GetServiceRequestEntity[]> {
    const apiCall = await api.get(`/api/service-request/get-requests-by-contract-number/${contractNumber}`, {
      functionName: 'serviceRequest_getServiceRequestsByContractNumber'
    } as AxiosRequestConfigWithMetadata)
    return apiCall.data
  }

  async getServiceRequestsByContractsList(contractsList: string, status: number, forceBtpRequest = false, page: number = 0, pageSize: number = 999): Promise<GetServiceRequestEntity[]> {
    const apiCall = await api.get('/api/service-request/get-requests-by-contracts-list', {
      params: {
        contractsList,
        status,
        forceBtpRequest,
        page,
        pageSize
      },
      functionName: 'serviceRequest_getServiceRequestsByContractsList'
    } as AxiosRequestConfigWithMetadata)
    return apiCall.data
  }

  async getServiceRequestFiles(srNumber: string): Promise<GetServiceRequestFilesEntity[]> {
    const apiCall = await api.get(`/api/service-request/files/${srNumber}`, {
      functionName: 'serviceRequest_getServiceRequestFiles'
    } as AxiosRequestConfigWithMetadata)
    return apiCall.data
  }

  async getServiceRequest(srNumber: string): Promise<GetServiceRequestFilesEntity> {
    const apiCall = await api.get(`/api/service-request/ticket/${srNumber}`, {
      functionName: 'serviceRequest_getServiceRequest'
    } as AxiosRequestConfigWithMetadata)
    return apiCall.data
  }
}

export const serviceRequestApi = new ServiceRequestApi()
